import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { UserManager, UserManagerSettings, User, WebStorageStateStore } from 'oidc-client';
import { BehaviorSubject, Subject } from 'rxjs';

import { BaseService } from "../../shared/base.service";
// import { environmentService } from '../../shared/Services/environmentsService.Service';

@Injectable({
  providedIn: 'root'
})

export class AuthService extends BaseService {

  // Observable navItem source
  private _authNavStatusSource = new BehaviorSubject<boolean>(false);
  // Observable navItem stream
  authNavStatus$ = this._authNavStatusSource.asObservable();

    // Observable navItem source
 private _userSource: Subject<User>= new Subject<User>();
 UserStatus$ = this._userSource.asObservable();

  private manager = new UserManager(getClientSettings());
  public redirectUrl:string=""
  static user: User | null = null;
  private user: User | null;

  constructor(private http: HttpClient) {
    super();
     ;
    this.manager.getUser().then(async user => {
       ;
      this.manager.storeUser(user);
      AuthService.user = user;
      this.user=user;
      this._authNavStatusSource.next(await this.isAuthenticated());
    });
  this.manager.events.addAccessTokenExpired(_=>{
    this._authNavStatusSource.next(false);
    //AuthService.user = null;
  })
  }

  login() {
    return this.manager.signinRedirect();
  }

   getUser(){
    this.manager.getUser().then(async user => {
       ;
      AuthService.user = user;
      this.user=user
      this._authNavStatusSource.next(await this.isAuthenticated());
    });
  }
  storUser(User:any)
  {
    this.manager.storeUser(User);
  }

  revokeAccessToken()
  {
    this.manager.revokeAccessToken();
  }

   signinSilent(){
     
    let x=this.manager.signinSilentCallback()
    x.then(s=>{
     //console.log(s)
    })
  }

  async completeAuthentication() {

     ;
    this.user = await this.manager.signinRedirectCallback();
    AuthService.user=this.user
     this._userSource.next(AuthService.user)
    this._authNavStatusSource.next(await this.isAuthenticated());
  }

  register(userRegistration: any) {
     ;
    return this.http.post('https://localhost:44335/api' + '/account', userRegistration);
  }


  async refreshToken(token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Authorization': token
      })
    };
    this.manager.revokeAccessToken
    return await this.http.post<any>(`$users/refresh-token`, httpOptions, { withCredentials: true }).subscribe((user)=>{
      this._userSource.next(user)
      AuthService.user=user
      this.user=user;
    })
}

   async isAuthenticated(allowedPermission? : number[]):Promise<boolean> {
    let user = await this.manager.getUser().then(user => {
      return user;
    })
  if(allowedPermission!=null&& allowedPermission!=undefined) 
  {
    if(allowedPermission.length==0)
    {
      return this.user != null && !this.user.expired;
    }
    else
    {
       ;
      let isUserInRole =this.isUserInRole(allowedPermission);
      return this.user != null && !this.user.expired&&isUserInRole;
    }

  }
  else
  return this.user != null && !this.user.expired;

        
  }
  isUserInRole(allowedPermission: number[])
  {
     ;
    let permissionSetSID =this.user.profile["permissionSetSID"].split`,`.map(x=>+x) as number[]
    return allowedPermission.every(i => permissionSetSID.includes(i));
  }

  authorizationHeaderValue(): string {
    return `${AuthService.user.token_type} ${AuthService.user.access_token}`;
  }

  name(): string {
     return AuthService.user != null ? AuthService.user.profile.given_name : '';
  }
  setUrl(url){
    localStorage.setItem("redirectUrl",url)
    
  }
  getUrl(){
    return localStorage.getItem("redirectUrl");
  }
  signinSilentCallback(){
  this.manager.signinSilentCallback()
  }
  async signout() {
    localStorage.clear();
    await this.manager.signoutRedirect();

  }
}

export function getClientSettings(): UserManagerSettings {
  return {
        // authority: environmentService.getIdentityServerUrl(),
        // client_id: 'angular_spa',
        // redirect_uri: environmentService.getIdentityServerUrl() +'/Admin/authentication/auth-callback',
        // post_logout_redirect_uri: environmentService.getBaseUrl() ,
        // response_type: "id_token token",
        // scope: "openid profile email IdentityServerApi",
        // filterProtocolClaims: true,
        // loadUserInfo: true,
        // automaticSilentRenew:true,
        // silent_redirect_uri:  environmentService.getIdentityServerUrl()+'/assets/silent-callback.html',
        // userStore: new WebStorageStateStore({ store: window.localStorage })
        };
}
